import React from "react";
import PropTypes from "prop-types";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/MatrixResultColumnHeaders.scss';

const MatrixResultColumnHeaders = ({ columns }) => {
  return (
    <div className="csw-r-mtrx-headers">
      <div className="csw-r-mtrx-header csw-r-mtrx-header-space"> </div>
      {columns &&
        columns.map((column, index) => {
          const { text } = column;
          return (
            <div className="csw-r-mtrx-header" key={`col-hdr-${index}`}>
              {text}
            </div>
          );
        })}
    </div>
  );
};

MatrixResultColumnHeaders.propTypes /* remove-proptypes */ = {
  columns: PropTypes.array.isRequired,
};

export default MatrixResultColumnHeaders;
